const THEME_STORAGE_KEY = 'theme';
const THEME_CHANGE_EVENT = 'app-theme-change';

export const getSystemTheme = () => {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return 'light';
  }

  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};

export const getStoredTheme = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  const storedTheme = window.localStorage.getItem(THEME_STORAGE_KEY);
  return storedTheme === 'dark' || storedTheme === 'light' ? storedTheme : null;
};

export const resolveTheme = () => getStoredTheme() || getSystemTheme();

export const applyTheme = (theme) => {
  if (typeof document === 'undefined') {
    return theme;
  }

  document.documentElement.setAttribute('data-theme', theme);
  return theme;
};

export const setTheme = (theme) => {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(THEME_STORAGE_KEY, theme);
  }

  applyTheme(theme);

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(THEME_CHANGE_EVENT, { detail: { theme } }));
  }

  return theme;
};

export const initializeTheme = () => {
  const theme = resolveTheme();

  if (!getStoredTheme() && typeof window !== 'undefined') {
    window.localStorage.setItem(THEME_STORAGE_KEY, theme);
  }

  return applyTheme(theme);
};

export const subscribeToThemeChange = (listener) => {
  if (typeof window === 'undefined') {
    return () => {};
  }

  const handleThemeChange = (event) => {
    listener(event.detail?.theme || resolveTheme());
  };

  window.addEventListener(THEME_CHANGE_EVENT, handleThemeChange);

  return () => {
    window.removeEventListener(THEME_CHANGE_EVENT, handleThemeChange);
  };
};
